module.exports = __webpack_public_path__ + "assets/9ee5726744a4d568bf385448991c1160.png";